import { formatBaht } from './money'
import type { Invoice } from '@/types'

/**
 * T149-088 (PAY-3 decision B): the label an invoice picker shows for one
 * unpaid invoice, in the owner's stated order: room, name, invoice number,
 * outstanding amount. Exported so T149-074's identify-payer modal reuses
 * the exact same wording rather than a second, driftable copy.
 *
 * The room is omitted (not shown as a placeholder) for an invoice with no
 * unit, e.g. an external-parker or customer-direct invoice.
 */
export function buildInvoiceOptionLabel(
  invoice: Pick<Invoice, 'number' | 'balance_due' | 'customer' | 'unit'>,
): string {
  const room = invoice.unit?.number
  const name = invoice.customer?.name ?? '-'
  const outstanding = formatBaht(invoice.balance_due, { decimals: 2 })
  return [room, name, invoice.number, outstanding].filter(Boolean).join(' · ')
}
